<template>
  <h-slug :to="blok.link" class="button" data-comp="a-button">
    {{ blok.text }}
  </h-slug>
</template>

<script setup>
defineProps({
  blok: {
    type: Object,
    default: () => ({})
  }
});
</script>
